import { Rectangle } from "../util";

/**
 * Canvas Context2D のラッパークラス
 */
export class CanvasRenderingContext2DWrapper {
  /**
   * Canvas Context2D
   */
  private readonly context: CanvasRenderingContext2D;

  constructor(context: CanvasRenderingContext2D) {
    this.context = context;
  }

  public drawImage(
    image: HTMLImageElement,
    from: Rectangle,
    to: Rectangle,
  ): void {
    this.context.drawImage(
      image,
      from.left,
      from.top,
      from.width,
      from.height,
      to.left,
      to.top,
      to.width,
      to.height,
    );
  }

  public clear(rect: Rectangle): void {
    this.context.clearRect(rect.left, rect.top, rect.width, rect.height);
  }
}
